import React from 'react';

import AuthorizedContentContainer from '../components/AuthorizedContentContainer/AuthorizedContentContainer';

import styles from './SingleColumnLayout.module.scss';

const SingleColumnLayout = ({ children }) => {
  return (
    <AuthorizedContentContainer>
      <div className={styles.container}>
        <main className={styles.column}>{children}</main>
      </div>
    </AuthorizedContentContainer>
  );
};

export default SingleColumnLayout;
